import { Collection, Nullable } from 'sdi/util';
import { IMapInfo, Inspire, IUser } from 'sdi/source';
import { Duration, Layout } from '../events/route';
import { Pair } from 'sdi/lib';

// State Augmentation
declare module 'sdi/shape' {
    export interface IShape {
        'app/layout': Layout;
        'app/theme': Nullable<string>;
        'app/global/info/duration': Duration;
        'app/baselayer/select': boolean;
        'app/source/new/edit': boolean;
        'app/text/edit': Nullable<Pair<string, boolean>>;
        'app/issue/zoom/auto': boolean;
        'app/issue/center/auto': boolean;
        'app/linked/change/id': Nullable<number>;
        'app/collapsible': Collection<boolean>;

        'data/maps': IMapInfo[];
        'data/datasetMetadata': Collection<Inspire>;
        'data/user': Nullable<IUser>;

        'remote/errors': Collection<string>;
    }
}

export const defaultAppShape = () => ({
    'app/layout': 'index' as Layout,
    'app/theme': null,
    'app/global/info/duration': 'week' as Duration,
    'app/baselayer/select': false,
    'app/source/new/edit': false,
    'app/text/edit': null,
    'app/issue/zoom/auto': true,
    'app/issue/center/auto': true,
    'app/linked/change/id': null,
    'app/collapsible': {
        legend: true,
        'global-info': true,
        'global-note': true,
        'detailed-informations': true,
    },

    'data/maps': [],
    'data/datasetMetadata': {},
    'data/user': null,

    'remote/errors': {},
});
